export const ON_SAVE_VERIFICATIONS = "ON_SAVE_VERIFICATIONS";

export const saveVerification = (payload) => {
  return {
    type: ON_SAVE_VERIFICATIONS,
    payload,
  };
};
